import Vue from 'vue'
import { login, mLogin, logout, phoneLogin,aggregateLogin } from "@/api/login"
import { ACCESS_TOKEN, USER_NAME, USER_INFO, USER_ROLE, USER_DEPART, WECHAT_INFO, USER_AUTH, SYS_BUTTON_AUTH, UI_CACHE_DB_DICT_DATA, TENANT_ID, TENANT_CONFIG,SYSTEM_INFO} from "@/store/mutation-types"
import { queryPermissionsByUser } from '@/api/api'
import { getAction } from '@/api/manage'

const user = {
  state: {
    token: '',
    username: '',
    realname: '',
    tenantid: '',
    welcome: '',
    avatar: '',
    permissionList: [],
    menuList: [],
    info: {},
    userRole: [],
    userDepart: [],
    wechat: {},
    tenantInfo:{}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { username, realname }) => {
      state.username = username
      state.realname = realname
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSIONLIST: (state, permissionList) => {
      state.permissionList = permissionList
    },
    SET_MENU: (state, menuList) => {
      state.menuList = menuList
    },
    SET_USER_INFO: (state, info) => {
      state.info = info
    },
    SET_USER_ROLE: (state, info) => {
      state.userRole = info
    },
    SET_USER_DEPART: (state, info) => {
      state.userDepart = info
    },
    SET_WECHAT_INFO: (state, info) => {
      state.wechat = info
    },
    SET_TENANT: (state, id) => {
      state.tenantid = id
    },
    SET_TENANT_CONFIG(state, tenantInfo){
      state.tenantInfo = tenantInfo;
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if (response.code == '200') {
            const result = response.result
            const userInfo = result.userInfo
            const userRole = result.role
            const userDepart = result.departs
            const wechatInfo = result.wechatInfo
            const systerInfo = {schoolName:response.result.schoolName,schoolLogo:response.result.schoolLogo}
            const expire = 7 * 24 * 60 * 60 * 1000
            Vue.ls.set(ACCESS_TOKEN, result.token, expire)
            Vue.ls.set(USER_NAME, userInfo.username, expire)
            Vue.ls.set(USER_INFO, userInfo, expire)
            Vue.ls.set(USER_ROLE, userRole, expire)
            Vue.ls.set(USER_DEPART, userDepart, expire)
            Vue.ls.set(WECHAT_INFO, wechatInfo, expire)
            Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, expire)
            Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, expire)
            Vue.ls.set(SYSTEM_INFO,systerInfo,expire)
            commit('SET_TOKEN', result.token)
            commit('SET_USER_INFO', userInfo)
            commit('SET_USER_ROLE', userRole)
            commit('SET_USER_DEPART', userDepart)
            commit('SET_WECHAT_INFO', wechatInfo)
            commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname })
            commit('SET_AVATAR', userInfo.avatar_url)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录
    mLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        mLogin(userInfo).then(response => {
          if (response.code == '200') {
            const result = response.result
            const userInfo = result.userInfo
            const userRole = result.role
            const userDepart = result.departs
            const wechatInfo = result.wechatInfo
            const systerInfo = {schoolName:response.result.schoolName,schoolLogo:response.result.schoolLogo}
            const expire = 7 * 24 * 60 * 60 * 1000
            Vue.ls.set(ACCESS_TOKEN, result.token, expire)
            Vue.ls.set(USER_NAME, userInfo.username, expire)
            Vue.ls.set(USER_INFO, userInfo, expire)
            Vue.ls.set(USER_ROLE, userRole, expire)
            Vue.ls.set(USER_DEPART, userDepart, expire)
            Vue.ls.set(WECHAT_INFO, wechatInfo, expire)
            Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, expire)
            Vue.ls.set(SYSTEM_INFO,systerInfo,expire)
            commit('SET_TOKEN', result.token)
            commit('SET_USER_INFO', userInfo)
            commit('SET_USER_ROLE', userRole)
            commit('SET_USER_DEPART', userDepart)
            commit('SET_WECHAT_INFO', wechatInfo)
            commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname })
            commit('SET_AVATAR', userInfo.avatar_url)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    //手机号登录
    PhoneLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        phoneLogin(userInfo).then(response => {
          if (response.code == '200') {
            const result = response.result
            const userInfo = result.userInfo
            const userRole = result.role
            const userDepart = result.departs
            const wechatInfo = result.wechatInfo
            const expire = 7 * 24 * 60 * 60 * 1000
            Vue.ls.set(ACCESS_TOKEN, result.token, expire)
            Vue.ls.set(USER_NAME, userInfo.username, expire)
            Vue.ls.set(USER_INFO, userInfo, expire)
            Vue.ls.set(USER_ROLE, userRole, expire)
            Vue.ls.set(USER_DEPART, userDepart, expire)
            Vue.ls.set(WECHAT_INFO, wechatInfo, expire)
            Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, expire)
            commit('SET_TOKEN', result.token)
            commit('SET_USER_INFO', userInfo)
            commit('SET_USER_ROLE', userRole)
            commit('SET_USER_DEPART', userDepart)
            commit('SET_WECHAT_INFO', wechatInfo)
            commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname })
            commit('SET_AVATAR', userInfo.avatar_url)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
        //聚合登录
    AggregateLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        aggregateLogin(userInfo).then(response => {
          if (response.code == '200') {
            const result = response.result
            const userInfo = result.userInfo
            const userRole = result.role
            const userDepart = result.departs
            const wechatInfo = result.wechatInfo
            const expire = 7 * 24 * 60 * 60 * 1000
            Vue.ls.set(ACCESS_TOKEN, result.token, expire)
            Vue.ls.set(USER_NAME, userInfo.username, expire)
            Vue.ls.set(USER_INFO, userInfo, expire)
            Vue.ls.set(USER_ROLE, userRole, expire)
            Vue.ls.set(USER_DEPART, userDepart, expire)
            Vue.ls.set(WECHAT_INFO, wechatInfo, expire)
            Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, expire)
            commit('SET_TOKEN', result.token)
            commit('SET_USER_INFO', userInfo)
            commit('SET_USER_ROLE', userRole)
            commit('SET_USER_DEPART', userDepart)
            commit('SET_WECHAT_INFO', wechatInfo)
            commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname })
            commit('SET_AVATAR', userInfo.avatar_url)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetPermissionList({ commit }) {
      return new Promise((resolve, reject) => {
        let v_token = Vue.ls.get(ACCESS_TOKEN);
        let params = { token: v_token };
        queryPermissionsByUser(params).then(response => {
          const menuData = response.result.menu;
          const authData = response.result.auth;
          const allAuthData = response.result.allAuth;
          //Vue.ls.set(USER_AUTH,authData);
          sessionStorage.setItem(USER_AUTH, JSON.stringify(authData));
          sessionStorage.setItem(SYS_BUTTON_AUTH, JSON.stringify(allAuthData));
          if (menuData && menuData.length > 0) {
            //update--begin--autor:qinfeng-----date:20200109------for：JEECG-63 一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------
            menuData.forEach((item, index) => {
              if (item["children"]) {
                let hasChildrenMenu = item["children"].filter((i) => {
                  return !i.hidden || i.hidden == false
                })
                if (hasChildrenMenu == null || hasChildrenMenu.length == 0) {
                  item["hidden"] = true
                }
              }
            })
            //console.log(" menu show json ", menuData)
            //update--end--autor:qinfeng-----date:20200109------for：JEECG-63 一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------
            commit('SET_PERMISSIONLIST', menuData)
          } else {
            reject('getPermissionList: permissions must be a non-null array !')
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        let logoutToken = state.token;
        commit('SET_TOKEN', '')
        commit('SET_PERMISSIONLIST', [])
        Vue.ls.remove(ACCESS_TOKEN)
        Vue.ls.remove(USER_NAME)
        Vue.ls.remove(USER_INFO)
        Vue.ls.remove(USER_ROLE)
        Vue.ls.remove(USER_DEPART)
        Vue.ls.remove(WECHAT_INFO)
        Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
        Vue.ls.remove(SYSTEM_INFO)
        logout(logoutToken).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    },
  }
}
export default user